<template>
  <div>
    <div class="header">
      <button
        class="back-button btn btn-transparent"
        @click="goBack()"
      >
        <arrow-left-icon />
      </button>

      <h1>Messages</h1>
    </div>

    <!-- From mockup -->
    <!-- <ul
      v-show="$route.name !== 'conversations_conversation'"
      class="navbar conversations-navbar"
    >
      <li>
        <router-link
          :to="{name: 'conversations_conversations'}"
          replace
        >
          Conversations
        </router-link>
      </li>
      <li>
        <router-link
          :to="{name: 'conversations_archived'}"
          replace
        >
          Archived
        </router-link>
      </li>
      <li>
        <router-link
          :to="{name: 'conversations_deleted'}"
          replace
        >
          Deleted
        </router-link>
      </li>
    </ul> -->
    <div :class="`conversation-content conversation-content-${$route.name}`">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConversationMain',
};
</script>

<style lang="scss" scoped>
.conversation {
  position: relative;
  padding-right: 25px;
}
.close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
}

  .header {
    position: fixed;
    top: 0;
    left: 0;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    width: 100%;
    height: var(--header-height);
    background-color: #fff;
    font-size: 1.25rem;
    z-index: 2;

    h1 {
      margin: 0;
      font-size: inherit;
    }
  }

  .back-button {
    padding: 0.375rem 0.75rem;
    font-size: inherit;
  }

  .conversations-navbar {
    position: fixed;
    top: var(--header-height);
    margin: 0 -15px;
    width: 100%;
  }

  .conversation-content {
    margin: calc(22px + 1rem) -15px 0;

    &.conversation-content-conversations_conversation {
      margin: 0;
    }
  }

  @media (min-width: 1024px) {
    .header {
      position: sticky;
      top: calc(var(--header-height) + 1rem);
      height: auto;
      background-color: var(--blue-lightest);
      box-shadow: -3px 0 0 0 var(--blue-lightest), 3px 0 0 0 var(--blue-lightest);
      z-index: 0;

      &:before {
        content: '';
        position: absolute;
        top: -1rem;
        width: 100%;
        height: 1rem;
        background-color: var(--blue-lightest);
        box-shadow: -3px 0 0 0 var(--blue-lightest), 3px 0 0 0 var(--blue-lightest);
      }

      .back-button {
        display: none;
      }

      h1 {
        margin-bottom: .67em;
      }
    }

    .conversations-navbar,
    .conversation-content {
      margin-right: 0;
      margin-left: 0;
    }

    .conversations-navbar {
      position: sticky;
      top: calc(var(--header-height) + 3.3rem);
      width: auto;
    }

    .conversation-content {
      margin-top: 1rem;
    }
  }
</style>
